import UserReducer from './UserReducer';
import DashboardReducer from './DashboardReducer';
import OrdersReducer from './OrdersReducer';
import ClientsReducer from './ClientsReducer';
import InvoicesReducer from './InvoicesReducer';
import InvoicePaymentsReducer from './InvoicePaymentsReducer';
import LabelsReducer from './LabelsReducer';
import ExportsReducer from './ExportsReducer';
import TemplatesReducer from './TemplatesReducer';
import TemplateReducer from './TemplateReducer';
import ExportReducer from './ExportReducer';
import BmailsReducer from './BmailsReducer';
import AddonsReducer from './AddonsReducer';
import EshopReducer from './EshopReducer';
import AccountingReducer from './AccountingReducer';
import StorageReducer from './StorageReducer';
import EmployeesReducer from './EmployeesReducer';
import EmployeeReducer from './EmployeeReducer';
import NotificationsReducer from './NotificationsReducer';
import SettingsReducer from './SettingsReducer';
import MarketplacesReducer from './MarketplacesReducer';
import AdminReducer from './AdminReducer';
import MenuReducer from './MenuReducer';
import OrderReducer from './OrderReducer';
import TrackTraceReducer from './TrackTraceReducer';
import ComplaintsReducer from './ComplaintsReducer';
import ComplaintReducer from './ComplaintReducer';
import MtoknaSellersReducer from './MtoknaSellersReducer';
import MtoknaOwnersReducer from './MtoknaOwnersReducer';
import MtoknaPointsReducer from './MtoknaPointsReducer';
import MtoknaOrdersReducer from './MtoknaOrdersReducer';
import MtoknaManualOrdersReducer from "./MtoknaManualOrdersReducer";
import MtoknaTemplatesReducer from "./MtoknaTemplatesReducer";
import MtoknaTemplateReducer from "./MtoknaTemplateReducer";
import MtoknaOwnerSmtpReducer from "./MtoknaOwnerSmtpReducer";
import MtoknaEshopReducer from "./MtoknaEshopReducer";
import AderynProductsReducer from "./AderynProductsReducer";
import AderynProductLogsReducer from "./AderynProductLogsReducer";
import MtoknaFilesReducer from "./MtoknaFilesReducer";
import CabProductsReducer from "./CabProductsReducer";
import MtoknaManualSellerOrdersReducer from "./MtoknaManualSellerOrdersReducer";
import MtoknaBannersReducer from "./MtoknaBannersReducer";
import MtoknaModeratorsReducer from "./MtoknaModeratorsReducer";
import MtoknaManualCustomerOrdersReducer from "./MtoknaManualCustomerOrdersReducer";
import MtoknaComplaintsReducer from "./MtoknaComplaintsReducer";
import MtoknaCategoriesReducer from "./MtoknaCategoriesReducer";
import MtoknaProductsReducer from "./MtoknaProductsReducer";
import MtoknaSchemesReducer from "./MtoknaSchemesReducer";
import MtoknaWindowSettingsReducer from "./MtoknaWindowSettingsReducer";
import MtoknaWindowSellerReducer from "./MtoknaWindowSellerReducer";
import MtoknaWindowsReducer from "./MtoknaWindowsReducer";
import MtoknaDocumentsReducer from "./MtoknaDocumentsReducer";
import MtoknaVideosReducer from "./MtoknaVideosReducer";
import MtoknaDogsReducer from "./MtoknaDogsReducer";
import MtoknaDogProductsReducer from "./MtoknaDogProductsReducer";
import RainproOrdersReducer from "./RainproOrdersReducer";
import RainproPickersReducer from "./RainproPickersReducer";
import MtoknaExcelSchemesReducer from "./MtoknaExcelSchemesReducer";
import CabOrdersReducer from "./CabOrdersReducer";
import PointsReducer from "./PointsReducer";
import FilesReducer from "./FilesReducer";
import AiFunctionsReducer from "./AiFunctionsReducer";
import AiCommandsReducer from "./AiCommandsReducer";
import AiCommandItemsReducer from "./AiCommandItemsReducer";
import FullProductsReducer from "./FullProductsReducer";
import AiAddonsReducer from "./AiAddonsReducer";
import AiChatbotQuestionsReducer from "./AiChatbotQuestionsReducer";
import AiChatbotThreadsReducer from "./AiChatbotThreadsReducer";
import MtoknaNewslettersReducer from "./MtoknaNewslettersReducer";
import MtoknaNewsletterReducer from "./MtoknaNewsletterReducer";
import CategoriesReducer from "./CategoriesReducer";
import AiTransactionsReducer from "./AiTransactionsReducer";
import AiMailerQuestionsReducer from "./AiMailerQuestionsReducer";
import AiMailerThreadsReducer from "./AiMailerThreadsReducer";
import EshopEnumsReducer from "./EshopEnumsReducer";
import MtoknaCodesReducer from "./MtoknaCodesReducer";
import RainproProductsReducer from "./RainproProductsReducer";
import RainproStoragesReducer from "./RainproStoragesReducer";
import RainproStorageItemsReducer from "./RainproStorageItemsReducer";
import RainproStorageLogsReducer from "./RainproStorageLogsReducer";
import RainproSchemesReducer from "./RainproSchemesReducer";
import DropxlLogsReducer from "./DropxlLogsReducer";
import RainproSellersReducer from "./RainproSellersReducer";
import RainproPointsReducer from "./RainproPointsReducer";
import RainproSellerOrdersReducer from "./RainproSellerOrdersReducer";
import MtoknaCampaignsReducer from "./MtoknaCampaignsReducer";
import MtoknaCampaignTemplateReducer from "./MtoknaCampaignTemplateReducer";
import MtoknaContactsReducer from "./MtoknaContactsReducer";
import MtoknaSellerComplaintsReducer from "./MtoknaSellerComplaintsReducer";
import RainproLabelsReducer from "./RainproLabelsReducer";
import EsatSchemesReducer from "./EsatSchemesReducer";
import EsatProductsReducer from "./EsatProductsReducer";
import MtoknaOwnerPointsReducer from "./MtoknaOwnerPointsReducer";
import MtoknaSellerNotesReducer from "./MtoknaSellerNotesReducer";
import AiAgentsReducer from "./AiAgentsReducer";
import AiAgentCommandsReducer from "./AiAgentCommandsReducer";
import RainproPointPackagesReducer from "./RainproPointPackagesReducer";
import MtoknaManualInvoicesReducer from "./MtoknaManualInvoicesReducer";
import RainproComplaintOrdersReducer from "./RainproComplaintOrdersReducer";
import JoklUsersReducer from "./JoklUsersReducer";
import JoklCreditsReducer from "./JoklCreditsReducer";
import JoklOrdersReducer from "./JoklOrdersReducer";
import JoklCouponsReducer from "./JoklCouponsReducer";

// Zoznam reducerov
export const reducers = {
    user: UserReducer,
    dashboard: DashboardReducer,
    orders: OrdersReducer,
    clients: ClientsReducer,
    invoices: InvoicesReducer,
    invoice_payments: InvoicePaymentsReducer,
    labels: LabelsReducer,
    exports: ExportsReducer,
    templates: TemplatesReducer,
    template: TemplateReducer,
    export_data: ExportReducer,
    bmails: BmailsReducer,
    addons: AddonsReducer,
    eshop: EshopReducer,
    accounting: AccountingReducer,
    storage: StorageReducer,
    employees: EmployeesReducer,
    employee: EmployeeReducer,
    notifications: NotificationsReducer,
    settings: SettingsReducer,
    marketplaces: MarketplacesReducer,
    admin: AdminReducer,
    menu: MenuReducer,
    order: OrderReducer,
    track_trace: TrackTraceReducer,
    complaints: ComplaintsReducer,
    complaint: ComplaintReducer,
    mtokna_sellers: MtoknaSellersReducer,
    mtokna_owners: MtoknaOwnersReducer,
    mtokna_points: MtoknaPointsReducer,
    mtokna_orders: MtoknaOrdersReducer,
    mtokna_manual_orders: MtoknaManualOrdersReducer,
    mtokna_templates: MtoknaTemplatesReducer,
    mtokna_template: MtoknaTemplateReducer,
    mtokna_newsletters: MtoknaNewslettersReducer,
    mtokna_newsletter: MtoknaNewsletterReducer,
    mtokna_owner_smtp: MtoknaOwnerSmtpReducer,
    mtokna_eshop: MtoknaEshopReducer,
    aderyn_products: AderynProductsReducer,
    aderyn_product_logs: AderynProductLogsReducer,
    mtokna_files: MtoknaFilesReducer,
    cab_products: CabProductsReducer,
    mtokna_manual_seller_orders: MtoknaManualSellerOrdersReducer,
    mtokna_banners: MtoknaBannersReducer,
    mtokna_moderators: MtoknaModeratorsReducer,
    mtokna_manual_customer_orders: MtoknaManualCustomerOrdersReducer,
    mtokna_complaints: MtoknaComplaintsReducer,
    mtokna_categories: MtoknaCategoriesReducer,
    mtokna_products: MtoknaProductsReducer,
    mtokna_schemes: MtoknaSchemesReducer,
    mtokna_window_settings: MtoknaWindowSettingsReducer,
    mtokna_window_seller: MtoknaWindowSellerReducer,
    mtokna_windows: MtoknaWindowsReducer,
    mtokna_documents: MtoknaDocumentsReducer,
    mtokna_videos: MtoknaVideosReducer,
    mtokna_dogs: MtoknaDogsReducer,
    mtokna_dog_products: MtoknaDogProductsReducer,
    rainpro_orders: RainproOrdersReducer,
    rainpro_pickers: RainproPickersReducer,
    mtokna_excel_schemes: MtoknaExcelSchemesReducer,
    cab_orders: CabOrdersReducer,
    points: PointsReducer,
    files: FilesReducer,
    ai_functions: AiFunctionsReducer,
    ai_commands: AiCommandsReducer,
    ai_command_items: AiCommandItemsReducer,
    full_products: FullProductsReducer,
    ai_addons: AiAddonsReducer,
    ai_chatbot_questions: AiChatbotQuestionsReducer,
    ai_chatbot_threads: AiChatbotThreadsReducer,
    categories: CategoriesReducer,
    ai_transactions: AiTransactionsReducer,
    ai_mailer_questions: AiMailerQuestionsReducer,
    ai_mailer_threads: AiMailerThreadsReducer,
    eshop_enums: EshopEnumsReducer,
    mtokna_codes: MtoknaCodesReducer,
    rainpro_products: RainproProductsReducer,
    rainpro_storages: RainproStoragesReducer,
    rainpro_storage_items: RainproStorageItemsReducer,
    rainpro_storage_logs: RainproStorageLogsReducer,
    rainpro_schemes: RainproSchemesReducer,
    dropxl_logs: DropxlLogsReducer,
    rainpro_sellers: RainproSellersReducer,
    rainpro_points: RainproPointsReducer,
    rainpro_seller_orders: RainproSellerOrdersReducer,
    mtokna_campaigns: MtoknaCampaignsReducer,
    mtokna_campaign_template: MtoknaCampaignTemplateReducer,
    mtokna_contacts: MtoknaContactsReducer,
    mtokna_seller_complaints: MtoknaSellerComplaintsReducer,
    rainpro_labels: RainproLabelsReducer,
    esat_schemes: EsatSchemesReducer,
    esat_products: EsatProductsReducer,
    mtokna_owner_points: MtoknaOwnerPointsReducer,
    mtokna_seller_notes: MtoknaSellerNotesReducer,
    ai_agents: AiAgentsReducer,
    ai_agent_commands: AiAgentCommandsReducer,
    rainpro_point_packages: RainproPointPackagesReducer,
    mtokna_manual_invoices: MtoknaManualInvoicesReducer,
    rainpro_complaint_orders: RainproComplaintOrdersReducer,
    jokl_users: JoklUsersReducer,
    jokl_credits: JoklCreditsReducer,
    jokl_orders: JoklOrdersReducer,
    jokl_coupons: JoklCouponsReducer,
};
